// @noflow
import './styles.css';

import NowTick from '../now';
import PropTypes from 'prop-types';
import * as React from 'react';
import TimelineTick from '../tick';
const TimelineTicksPropTypes = {
    tickData: PropTypes.array.isRequired
};

const TimelineTicks = ({ tickData }) => {
    return (
        <div className="logs-timeline-component__ticks">
            {tickData.map(tick => {
                if (tick.type === 'now') {
                    return <NowTick key="tick-now" style={tick.style} />;
                } else {
                    return <TimelineTick key={`tick-${tick.index}`} {...tick} />;
                }
            })}
        </div>
    );
};

TimelineTicks.propTypes = TimelineTicksPropTypes;

export default TimelineTicks;



// WEBPACK FOOTER //
// ./src/components/widgets/logs-timeline/timeline/ticks/index.js